import type { KnowledgeBaseRepository } from "../repositories/knowledge-base-repository"

export const makeGetKnowledgeBases = (repo: KnowledgeBaseRepository) =>
  (params: { page: number; limit: number; name?: string }) =>
    repo.list(params)
